import axios from "axios"
import { getAuth, useAuth } from "../../modules/auth"
import { RadioInput } from "../RadioInputs"
import { closeModalFunction, closeModalIcon } from "../dictionary"
import { useEffect, useState } from "react"
import { handleUpdateUserData } from "../../pages/UserProfile"
import { SEND_BOOST_TEST_SCORE_INFO_EMAIL } from "../../modules/auth/core/_requests"
import { collegeMap } from "../collegeMap"

const BoostScoresModal = ({ user, setUser, userCollegeInterest, setShowBoostScoresToast, selectedRadio, setSelectedRadio }) => {

  let apiToken: any = undefined

  if (getAuth()?.api_token && getAuth()?.groups) {
    apiToken = getAuth()?.api_token
  }

  const { currentUser } = useAuth()

  // const radioMap = {
  //   0: 'Not Sure Yet',
  //   1: 'SAT',
  //   2: 'ACT',
  //   3: 'SAT & ACT'
  // }

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const updateScreenSize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  const returnInputWidth = (screenWidth) => {
    switch (true) {
      case screenWidth >= 768:
        return "334px"
      case screenWidth < 768 && screenWidth >= 576:
        return "280px"
      case screenWidth < 576 && screenWidth >= 390:
        return "240px"
      case screenWidth < 390:
        return "200px"
    }
  }

  const handleSubmit = async (user, userCollegeInterest, selectedRadio): Promise<boolean> => {
    try {
      await handleUpdateUserData(user, { testScoreCTA: true }, setUser, apiToken);

      const returnSelectedRadioStringFromVal = (selectedRadio) => {
        switch (selectedRadio) {
          case 0:
            return 'Not Sure Yet'
          case 1:
            return 'SAT'
          case 2:
            return 'ACT'
          case 3:
            return 'SAT & ACT'
          default:
            return 'N/A. Error returning selected radio value.'
        }
      }

      const userName = user?.lastName != null && user?.lastName != undefined ? `${user?.firstName} ${user?.lastName}` : `${user?.firstName ? user?.firstName : 'N/A'}`

      const savedCollegeList =
        Array.isArray(userCollegeInterest) && userCollegeInterest.length > 0
          ? userCollegeInterest
            .map(college => collegeMap.find(col => `${col.id}` === `${college.college_id}`)?.name)
            .filter(Boolean)
          : null;

      let postData = savedCollegeList != null ? {
        name: userName,
        email: user?.emailAddress ?? 'N/A',
        selectedRadio: returnSelectedRadioStringFromVal(selectedRadio),
        testScoreList: {
          'satMath': user?.satMath ?? null,
          'satVerbal': user?.satVerbal ?? null,
          'actComposite': user?.actComposite ?? null
        },
        userCollegeInterest: savedCollegeList
      } : {
        name: userName,
        email: user?.emailAddress ?? 'N/A',
        selectedRadio: returnSelectedRadioStringFromVal(selectedRadio),
        testScoreList: {
          'satMath': user?.satMath ?? null,
          'satVerbal': user?.satVerbal ?? null,
          'actComposite': user?.actComposite ?? null
        }
      }

      await axios.post(SEND_BOOST_TEST_SCORE_INFO_EMAIL, postData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return true
    } catch (error) {
      console.log("Submission events failed:", error);
      return false
    }
  }

  return (<div className="modal fade" id="boostScoresModal">
    <div className="modal-dialog modal-dialog modal-dialog-centered">
      <div className="modal-content dca-editscore-profile-modal">

        <div className="modal-body fw-bold d-flex flex-column">

          {closeModalIcon('boostScoresModal')}

          <p className="dca-testscore-editscore-title" style={{ fontWeight: 'normal' }}>Boost Your Test Scores With The Best Help</p>

          <span style={{ fontWeight: 'normal' }}>NextFour has partnered with curated test preparation companies with a proven track-record of helping students optimize their SAT/ACT test scores. Please indicate where you would like to improve:</span>

          <div className="d-flex flex-column justify-content-center" style={{ margin: '20px auto' }}>
            <RadioInput selectedState={selectedRadio === 1} onClick={() => {
              selectedRadio === 1 ? setSelectedRadio(null) : setSelectedRadio(1)
            }} name="testName" id="sat" text={`SAT`} maxWidth="334px" widthOverride={returnInputWidth(screenWidth)} />

            <RadioInput selectedState={selectedRadio === 2} onClick={() => {
              selectedRadio === 2 ? setSelectedRadio(null) : setSelectedRadio(2)
            }} name="testName" id="act" text={`ACT`} widthOverride={returnInputWidth(screenWidth)} mt={'10px'} mobileMT={'18px'} />

            <RadioInput selectedState={selectedRadio === 3} onClick={() => {
              selectedRadio === 3 ? setSelectedRadio(null) : setSelectedRadio(3)
            }} name="testName" id="sat_and_act" text={`SAT & ACT`} widthOverride={returnInputWidth(screenWidth)} mt={'10px'} mobileMT={'18px'} />

            <RadioInput selectedState={selectedRadio === 0} onClick={() => {
              selectedRadio === 0 ? setSelectedRadio(null) : setSelectedRadio(0)
            }} name="testName" id="notSure" text={`Not sure yet`} widthOverride={returnInputWidth(screenWidth)} mt={'10px'} mobileMT={'18px'} />

            <button disabled={selectedRadio === null} className="dca-testScore-modal-email-button" onClick={async () => {
              const success = await handleSubmit(user, userCollegeInterest, selectedRadio);
              // const success = true

              if (success) {
                closeModalFunction('boostScoresModal');
                setShowBoostScoresToast(true)
              }
            }}>Email me more info</button>
          </div>

          <span style={{ fontWeight: 'normal' }}>Opting into this offer will allow you to receive some details about NextFour partner(s). There is no obligation to proceed and no information will be shared with third-parties at this time.</span>
        </div>

      </div>
    </div>
  </div>)
}

export { BoostScoresModal }